import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/Observable';
import { map, catchError } from 'rxjs/operators';

/*
  Generated class for the RestProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class RestProvider {

  // private baseUrl     = 'http://staging.vggo.be/index.php?p=actions/vggo/app/';
  private baseUrl     = 'https://tool.vggo.be/index.php?p=actions/vggo/app/';
  private key = 'ahiR4Mt8MPdOf12gKNFU0CAxpVfRN4kp';

  constructor(public http: HttpClient) {
  }

  getAuctions(): Observable<{}> {
    let postData = new FormData();
    postData.append('key', this.key);
    return this.http.post(this.baseUrl + 'getAuctions', postData).pipe(
      map(function(res: Response){return res}),
      catchError(this.handleError)
    );
  }

  getLotsForAuction(id): Observable<{}> {
    let postData = new FormData();
    postData.append('key', this.key);
    postData.append('id', id);
    return this.http.post(this.baseUrl + 'getLotsForAuction', postData).pipe(
      map(function(res: Response){return res}),
      catchError(this.handleError)
    );
  }

  getLot(id): Observable<{}> {
    let postData = new FormData();
    postData.append('id', id);
    postData.append('key', this.key);
    return this.http.post(this.baseUrl + 'getLotById', postData).pipe(
      map(function(res: Response){console.log(res); return res}),
      catchError(this.handleError)
    );
    // return this.http.get(this.lotUrl + id).pipe(
    //   map(this.extractData),
    //   catchError(this.handleError)
    // );
  }

  removeBuyer(id): Observable<{}> {
    let postData = new FormData();
    postData.append('id', id);
    postData.append('key', this.key);
    return this.http.post(this.baseUrl + 'removeBuyer', postData).pipe(
      map(function(res: Response){return res}),
      catchError(this.handleError)
    );
  }

  setBuyer(lotId, buyerId){
    let postData = new FormData();
    postData.append('id', lotId);
    postData.append('buyerId', buyerId);
    postData.append('key', this.key);
    return this.http.post(this.baseUrl + 'setBuyer', postData).pipe(
      map(function(res: Response){return res}),
      catchError(this.handleError)
    );
  }

  setPickedUpStatus(id, value): Observable<{}> {
    let postData = new FormData();
    postData.append('id', id);
    postData.append('value', value);
    postData.append('key', this.key);
    return this.http.post(this.baseUrl + 'setPickedUp', postData).pipe(
      map(function(res: Response){return res}),
      catchError(this.handleError)
    );
  }

  setPaidStatus(id, value): Observable<{}> {
    let postData = new FormData();
    postData.append('id', id);
    postData.append('value', value);
    postData.append('key', this.key);
    return this.http.post(this.baseUrl + 'setPaid', postData).pipe(
      map(function(res: Response){return res}),
      catchError(this.handleError)
    );
  }

  removeImageById(id): Observable<{}> {
    // '/actions/assets/deleteFile'
    let postData = new FormData();
    postData.append('id', id);
    postData.append('key', this.key);
    return this.http.post(this.baseUrl + 'deleteFile', postData).pipe(
      map(function(res: Response){return res}),
      catchError(this.handleError)
    );
  }

	private extractData(res: Response) {
	  let body = res;
	  return body || { };
	}

	private handleError (error: Response | any) {
	  let errMsg: string;
	  if (error instanceof Response) {
	    const err = error || '';
	    errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
	  } else {
	    errMsg = error.message ? error.message : error.toString();
	  }
	  console.error(errMsg);
	  return Observable.throw(errMsg);
	}

  checkConnection(){
    return navigator.onLine;
  }

}



// WEBPACK FOOTER //
// ./src/providers/rest/rest.ts